import { render, staticRenderFns } from "./HelpCard.vue?vue&type=template&id=3a597aa2&scoped=true"
import script from "./HelpCard.vue?vue&type=script&lang=js"
export * from "./HelpCard.vue?vue&type=script&lang=js"
import style0 from "./HelpCard.vue?vue&type=style&index=0&id=3a597aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a597aa2",
  null
  
)

export default component.exports